// Automatically detect if running on localhost or production
const isLocalhost = window.location.hostname === 'localhost' || 
                    window.location.hostname === '127.0.0.1' || 
                    window.location.hostname === '::1';

// If running on localhost, use local server (port 5050 to avoid macOS AirPlay conflicts)
// If running on production domain, use Railway production server
const resolvedUrl = isLocalhost 
  ? 'http://localhost:5050'
  : 'https://18graf-production.up.railway.app';

export const API_URL = resolvedUrl;